import type React from 'react';

export interface PageHeaderActionsProps {
  children: React.ReactNode;
}

const PageHeaderActions = ({ children }: PageHeaderActionsProps) => {
  return <div className='flex items-center gap-5 self-start tablet:self-end'>{children}</div>;
};

export default PageHeaderActions;
